import { Box, Button } from '@/components';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import invariant from 'tiny-invariant';

import { useCommentStackSiderView } from '@/features/comment/hooks/stack-sider-view';

export const CommentSiderListHeader: FC = () => {
  const { t } = useTranslation();
  const stackSiderView = useCommentStackSiderView();

  const stackSiderViewConfig = stackSiderView.lastItem?.config;

  invariant(stackSiderViewConfig, t('unreachable-code'));

  return (
    <Box>
      <Button
        type="primary"
        onClick={() => {
          stackSiderView.push({
            payload: {
              config: {
                viewType: 'comment-form',
                isEditing: false,
                target: stackSiderViewConfig.target,
              },
            },
            target: stackSiderView.target,
          });
        }}
      >
        {t('create')}
      </Button>
    </Box>
  );
};
